<template>
  <div class="">
    <edit-cash-entries> </edit-cash-entries>
  </div>
</template>

<script>
import EditCashEntries from "@/components/accounting/cash-entries/book-entries/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "removeBreadcrumbs" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    EditCashEntries,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Movimento Contabile",
        path: "movimenti_prima_nota.edit0",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Movimento Contabile",
        path: "movimenti_prima_nota.edit0",
        level: 4,
      });
    }
  },
};
</script>
